var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 32,
    viewBox: "0 0 145 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6633 -0.000244141H31.1992V31.9843H37.6633V-0.000244141Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0451 31.9896C46.4702 31.9896 41.1211 26.6388 41.1211 20.0618C41.1211 13.4848 46.4702 8.13403 53.0451 8.13403C59.6201 8.13403 64.9691 13.4848 64.9691 20.0618C64.9691 26.6388 59.6201 31.9896 53.0451 31.9896ZM53.0451 14.6002C50.0347 14.6002 47.5852 17.0504 47.5852 20.0618C47.5852 23.0732 50.0347 25.5234 53.0451 25.5234C56.0556 25.5234 58.505 23.0732 58.505 20.0618C58.505 17.0504 56.0556 14.6002 53.0451 14.6002Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.68 31.9715H103.216V20.0599C103.216 17.0485 100.766 14.5983 97.7561 14.5983C94.7456 14.5983 92.2962 17.0485 92.2962 20.0599H85.832C85.832 13.4829 91.1811 8.13208 97.7561 8.13208C104.331 8.13208 109.68 13.4829 109.68 20.0599V31.9715Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4846 31.9997C74.9096 31.9997 69.5605 26.649 69.5605 20.072V3.23218H76.0247V20.072C76.0247 23.0833 78.4741 25.5336 81.4846 25.5336V31.9997Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1672 10.469H67.2578V16.9352H81.1672V10.469Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M144.004 31.9997C137.429 31.9997 132.08 26.649 132.08 20.072V3.23218H138.544V20.072C138.544 23.0833 140.994 25.5336 144.004 25.5336V31.9997Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M143.673 10.469H129.764V16.9352H143.673V10.469Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2962 -0.000244141H85.832V31.9843H92.2962V-0.000244141Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M126.669 8.16162H120.205V31.9849H126.669V8.16162Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M126.669 3.23285C126.669 1.44726 125.222 -0.000244141 123.437 -0.000244141C121.652 -0.000244141 120.205 1.44726 120.205 3.23285C120.205 5.01843 121.652 6.46593 123.437 6.46593C125.222 6.46593 126.669 5.01843 126.669 3.23285Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7191 22.7263C19.0069 26.4398 12.9652 26.4398 9.25294 22.7263C5.54069 19.0129 5.54069 12.9693 9.25294 9.25588C12.9652 5.54244 19.0069 5.54244 22.7191 9.25588L27.2902 4.68336C21.0477 -1.56112 10.9244 -1.56112 4.68188 4.68336C-1.56063 10.9278 -1.56063 21.0543 4.68188 27.2988C10.9244 33.5433 21.0477 33.5433 27.2902 27.2988L22.7191 22.7263Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2fdceab5aef89b44854a6128100a5317.svg";
export { ForwardRef as ReactComponent };